import { createContext, useContext } from "react";
import pl from "./i18n.pl.json";

// ════════════════════════════════════════════════════════════════════════════
//  KitchenControl — meertaligheid (i18n)
//  ----------------------------------------------------------------------------
//  Werkwijze: de NEDERLANDSE tekst in de code is meteen de "sleutel".
//  - Voor Nederlands hoeft er dus niets vertaald te worden (de sleutel = de tekst).
//  - Andere talen mappen de Nederlandse tekst -> de vertaling (zie DICTS hieronder).
//  - Mist een vertaling, dan valt t() automatisch terug op het Nederlands.
//
//  In de code:  t("Opslaan")            -> "Save" (en) / "Opslaan" (nl)
//  Met variabele: t("Week {n}", { n: 25 })
//
//  Een taal toevoegen = één extra woordenboek hieronder. That's it.
// ════════════════════════════════════════════════════════════════════════════

// Talen die in de keuzelijst verschijnen
export const TALEN = [
  { code: "nl", label: "Nederlands" },
  { code: "en", label: "English" },
  { code: "pl", label: "Polski" },
];

export const DICTS = {
  // Nederlands is de bron — leeg laten, t() valt terug op de sleutel zelf.
  nl: {},
  pl,

  en: {
"Terugkoeling loopt — open HACCP": "Cooling in progress — open HACCP",
"Terugkoelstatus niet bijgewerkt. Controleer HACCP.": "Cooling status not updated. Check HACCP.",
    "Dit product moet worden teruggekoeld": "This product needs cooling",
    "Start zelf een meting via de thermometer in de lijst. Afvinken start geen terugkoeling.": "Start a measurement yourself using the thermometer in the list. Ticking off an item does not start cooling.",
    "Terugkoeling starten": "Start cooling",
    // ── Begroeting ──────────────────────────────────────────────────────────
    "Welkom": "Welcome",
    "Goedemorgen": "Good morning",
    "Goedemiddag": "Good afternoon",
    "Goedenavond": "Good evening",

    // ── Schil / beginpagina ─────────────────────────────────────────────────
    "Kies een module om te beginnen.": "Choose a module to get started.",
    "verbonden": "connected",
    "Uitloggen": "Log out",
    "Begin": "Home",
    "Beginpagina": "Home",
    "+ {n} meer": "+ {n} more",
    "Minder tonen": "Show less",
    "powered by": "powered by",
    "Stel je locatie in via Instellingen → Bedrijf om hier het weer te zien.":
      "Set your location via Settings → Company to see the weather here.",
    "Je omgeving wordt geladen…": "Loading your workspace…",
    "Laden…": "Loading…",
    "Taal": "Language",

    // ── Weer-widget ─────────────────────────────────────────────────────────
    "Weer laden…": "Loading weather…",
    "Weer kon niet geladen worden voor “{plaats}”. Controleer de plaatsnaam in Instellingen.":
      "Could not load the weather for “{plaats}”. Check the location name in Settings.",
    "weer via Open-Meteo": "weather via Open-Meteo",

    // ── Module-overzicht ────────────────────────────────────────────────────
    "Kies een onderdeel om mee te werken.": "Choose a section to work with.",
    "Beheer": "Management",

    // ── Modulenamen ─────────────────────────────────────────────────────────
    "Mise En Place": "Mise en place",
    "Recepten": "Recipes",
    "Team": "Team",
    "HACCP": "HACCP",
    "Instellingen": "Settings",

    // ── Onderdelen: MEP ─────────────────────────────────────────────────────
    "Mep lijst": "Prep list",
    "Het dagelijkse overzicht: zie per afdeling en dag wat klaargemaakt moet worden en vink af.":
      "The daily overview: see per section and day what needs to be prepared, and tick it off.",
    "Nieuwe afdeling": "New section",
    "Maak een afdeling zoals Warme kant of Garde. Afdelingen groeperen je categorieën.":
      "Create a section such as Hot side or Garde. Sections group your categories.",
    "Nieuwe categorie": "New category",
    "Voeg een categorie toe binnen een afdeling, zoals Vlees, Vis of Sauzen.":
      "Add a category within a section, such as Meat, Fish or Sauces.",
    "Nieuw item": "New item",
    "Voeg een mep-item toe met hoeveelheid, eenheid en eventueel een gekoppeld recept.":
      "Add a prep item with quantity, unit and optionally a linked recipe.",
    "Bestelbon": "Order sheet",
    "Stel automatisch een bestellijst samen uit je bestelartikelen, gegroepeerd per leverancier — klaar om te printen.":
      "Automatically compile an order list from your order items, grouped by supplier — ready to print.",
    "Archief": "Archive",
    "Bekijk en herstel items die je hebt gearchiveerd.":
      "View and restore items you have archived.",

    // ── Onderdelen: Recepten ────────────────────────────────────────────────
    "Blader door al je recepten, bekijk, bewerk en print ze.":
      "Browse all your recipes, view, edit and print them.",
    "Nieuw recept": "New recipe",
    "Maak een recept aan met ingrediënten, bereiding en allergenen.":
      "Create a recipe with ingredients, preparation and allergens.",
    "Recept plakken": "Paste recipe",
    "Plak een recept als tekst en laat het automatisch omzetten naar een net recept.":
      "Paste a recipe as text and have it automatically turned into a neat recipe.",
    "Categorieën": "Categories",
    "Beheer de categorieën waarin je recepten worden ingedeeld.":
      "Manage the categories your recipes are sorted into.",

    // ── Onderdelen: Team ────────────────────────────────────────────────────
    "Medewerkers": "Staff",
    "Beheer je personeel: naam, telefoon, e-mail en functie.":
      "Manage your staff: name, phone, email and role.",
    "Werktijden": "Working hours",
    "Vul het weekrooster in: begin- en eindtijden per medewerker.":
      "Fill in the weekly schedule: start and end times per employee.",

    // ── Onderdelen: HACCP ───────────────────────────────────────────────────
    "Schoonmaak": "Cleaning",
    "Registreer uitgevoerde schoonmaaktaken.": "Log completed cleaning tasks.",
    "Temperatuur": "Temperature",
    "Leg temperatuurmetingen vast van koelingen, vriezers en gerechten.":
      "Record temperature readings of fridges, freezers and dishes.",
    "Ontvangst": "Receiving",
    "Registreer goederenontvangst en controleer je leveringen.":
      "Log goods receipt and check your deliveries.",
    "Terugkoelen": "Cooling down",
    "Volg het terugkoelen van gerechten binnen de NVWA-norm.":
      "Track the cooling of dishes within the food-safety standard.",
    "Allergenen": "Allergens",
    "Houd allergeneninformatie van je gerechten bij.":
      "Keep allergen information of your dishes up to date.",
    "Afwijkingen": "Deviations",
    "Leg afwijkingen en corrigerende maatregelen vast.":
      "Record deviations and corrective actions.",
    "Hygiëne": "Hygiene",
    "Registreer je hygiënecontroles.": "Log your hygiene checks.",
    "Beheer je koelunits, leveranciers en andere HACCP-instellingen.":
      "Manage your fridge units, suppliers and other HACCP settings.",

    // ── MEP-module ──────────────────────────────────────────────────────────
    // Sync / header / zoeken
    "synchroniseren…": "syncing…",
    "sync fout": "sync error",
    "gesynchroniseerd": "synced",
    "Afdrukken": "Print",
    "Zoeken…": "Search…",
    "Week {n}": "Week {n}",
    // Dagen (let op: "Ma".."Zo" blijven de opslagsleutels; hier alleen de weergave)
    "Ma": "Mon", "Di": "Tue", "Wo": "Wed", "Do": "Thu", "Vr": "Fri", "Za": "Sat", "Zo": "Sun",
    // Lijst
    "Nog geen items. Voeg een categorie en item toe via de zijbalk.":
      "No items yet. Add a category and item via the sidebar.",
    "RECEPT": "RECIPE",
    "Naar morgen": "To tomorrow",
    // Bestelbon
    "Geen items gepland deze week.": "No items planned this week.",
    "Vink items aan in de weekplanning om ze op de bestelbon te zetten.":
      "Tick items in the weekly planning to add them to the order sheet.",
    "artikel": "item",
    "artikelen": "items",
    "Whiteboard — op / bijna op": "Whiteboard — out / almost out",
    "Op": "Out",
    "Bijna op": "Almost out",
    "Geregeld": "Sorted",
    "via:": "via:",
    // Archief
    "Item definitief verwijderen?": "Permanently delete item?",
    "Geen gearchiveerde items.": "No archived items.",
    "Herstellen": "Restore",
    // Allergenen (officiële EU-namen)
    "Gluten": "Gluten", "Schaaldieren": "Crustaceans", "Eieren": "Eggs", "Vis": "Fish",
    "Pindas": "Peanuts", "Soja": "Soy", "Melk": "Milk", "Noten": "Nuts",
    "Selderij": "Celery", "Mosterd": "Mustard", "Sesamzaad": "Sesame",
    "Zwaveldioxide": "Sulphur dioxide", "Lupine": "Lupin", "Weekdieren": "Molluscs",
    "Gluten — specificeer graansoort": "Gluten — specify grain",
    "Noten — specificeer soort": "Nuts — specify type",
    "Tarwe": "Wheat", "Rogge": "Rye", "Gerst": "Barley", "Haver": "Oats",
    "Amandelen": "Almonds", "Hazelnoten": "Hazelnuts", "Walnoten": "Walnuts",
    "Cashewnoten": "Cashews", "Pecannoten": "Pecans", "Paranoten": "Brazil nuts",
    "Pistachenoten": "Pistachios", "Macadamianoten": "Macadamia nuts",
    // Item-popup
    "Item bewerken": "Edit item",
    "Naam *": "Name *",
    "Naam van het item": "Item name",
    "Afdeling": "Section",
    "Kies…": "Choose…",
    "Categorie": "Category",
    "Geen": "None",
    "Notitie": "Note",
    "Optionele notitie…": "Optional note…",
    "Recept": "Recipe",
    "Nog geen recepten — voeg ze toe in Receptenbeheer":
      "No recipes yet — add them in Recipe management",
    "— Geen recept gekoppeld —": "— No recipe linked —",
    "Bekijk recept →": "View recipe →",
    "Bewaaradvies": "Storage advice",
    "— geen —": "— none —",
    "Bewaartermijn (dagen)": "Shelf life (days)",
    "bijv. {n}": "e.g. {n}",
    "Richtlijn houdbaarheid:": "Shelf-life guideline:",
    "2 dagen onder 7 °C · 3 dagen onder 4 °C": "2 days below 7 °C · 3 days below 4 °C",
    "Bewaren onder 7°C": "Store below 7°C",
    "Bewaren onder -18°C": "Store below -18°C",
    "Bewaren op kamertemperatuur": "Store at room temperature",
    "Direct serveren": "Serve immediately",
    "Bestelartikelen": "Order items",
    "Nog geen bestelartikelen.": "No order items yet.",
    "Bewerken": "Edit",
    "Verwijderen": "Delete",
    "Artikel naam *": "Item name *",
    "Onthouden artikelen": "Saved items",
    "bestaand": "existing",
    "Hoev.": "Qty",
    "Leverancier": "Supplier",
    "Bijwerken": "Update",
    "Toevoegen": "Add",
    "Annuleren": "Cancel",
    "Opslaan": "Save",
    "Etiket": "Label",
    "Item verwijderen?": "Delete item?",
    // Eenheden (kg/g/L/ml blijven gelijk via de terugval)
    "stuks": "pcs", "bos": "bunch", "blik": "can", "zak": "bag",
    "el": "tbsp", "tl": "tsp", "snuf": "pinch", "overig": "other",
    // Afdeling-/categorie-popup
    "Afdelingen beheren": "Manage sections",
    'Afdeling "{naam}" en alle bijbehorende categorieën verwijderen?':
      'Delete section "{naam}" and all its categories?',
    "Nieuwe afdeling…": "New section…",
    "Categorieën beheren": "Manage categories",
    'Categorie "{naam}" verwijderen? Items verhuizen naar "Geen categorie".':
      'Delete category "{naam}"? Items move to "No category".',
    "Nog geen categorieën in deze afdeling.": "No categories in this section yet.",
    "Nieuwe categorie…": "New category…",
    // Etiket printen
    "etiket": "label",
    "etiketten": "labels",
    "geprint": "printed",
    "Etiket printen": "Print label",
    "controleren…": "checking…",
    "printer online": "printer online",
    "printer offline": "printer offline",
    "Productiedatum": "Production date",
    "THT (dagen)": "Best before (days)",
    "Medewerker": "Employee",
    "Aantal": "Quantity",
    "minder": "less",
    "meer": "more",
    'Geen recept gekoppeld — allergenen en bewaaradvies komen van het item zelf (aan te passen via "Item bewerken").':
      'No recipe linked — allergens and storage advice come from the item itself (edit via "Edit item").',
    "Printen…": "Printing…",
    "Printer offline": "Printer offline",
    "Print {n} etiketten": "Print {n} labels",
    "Print etiket": "Print label",
    // ── Dashboard — aanvullende vertalingen ──────────────────────────────────
    "Weer laden...": "Loading weather...",
    "Weer kon niet geladen worden voor {plaats}. Controleer de plaatsnaam in Instellingen.":
      "Could not load the weather for {plaats}. Check the location name in Settings.",
    "Wat vraagt vandaag aandacht?": "What needs attention today?",
    "Mise En Place vandaag": "Today's mise en place",
    "open": "open",
    "klaar": "done",
    "Feestdag in zicht": "Upcoming public holiday",
    "Vandaag": "Today",
    "Over {n} dagen": "In {n} days",
    "controleer bestel- en leverdagen": "check ordering and delivery days",
    "Recepten en allergenen": "Recipes and allergens",
    "Medewerkers en rooster": "Staff and schedule",
    "Controles en rapportage": "Checks and reporting",
    "Stel je locatie in via Instellingen - Bedrijf om hier het weer te zien.":
      "Set your location via Settings - Company to see the weather here.",
    "Snel naar": "Quick access",
    "Lopende terugkoeling": "Active cooling process",
    "Terugkoeling": "Cooling",
    "Langer dan 5 uur bezig": "Running for more than 5 hours",
    "Bezig": "In progress",
    "HACCP aandacht": "HACCP attention",
    "Deze week nog niet geregistreerd": "Not yet logged this week",
    "Terug": "Back",
    "Goedendag": "Hello",
    "Dit vraagt vandaag aandacht in de keuken.": "This needs attention in the kitchen today.",
    "Hulp": "Help",
    "Hulp openen": "Open help",
    "Hulp over": "Help about",
    "Open": "Open",
    "Dit account is beveiligd met een beheer-pincode": "This account is protected with a management PIN",
    "Deze KitchenControl-omgeving is nog niet beveiligd": "This KitchenControl workspace is not yet protected",
    "Wijzigingen en verwijderingen zijn beschermd. Klik om de beheer-pincode te beheren.": "Changes and deletions are protected. Click to manage the management PIN.",
    "Iedereen die deze login gebruikt kan ook wijzigingen en verwijderingen uitvoeren. Stel een beheer-pincode in als dit een gedeelde tablet is.": "Anyone using this login can also make changes and deletions. Set a management PIN if this is a shared tablet.",
    "Mise en Place": "Mise en place",
    "taken open": "tasks open",
    "van": "of",
    "voltooid": "completed",
    "Dagelijks": "Daily",
    "Wekelijks": "Weekly",
    "4-wekelijks": "Every 4 weeks",
    "Laatst": "Latest",
    "ingevoerde recepten": "saved recipes",
    "teamleden": "team members",
    "open items": "open items",
    "Printer": "Printer",
    "Printkastje": "Print box",
    "Abonnement": "Subscription",
    "actief": "active",
    "intern": "internal",
    "proefperiode": "trial",
    "betaling openstaand": "payment outstanding",
    "opgezegd": "cancelled",
    "verlopen": "expired",
    "maandelijks": "monthly",
    "jaarlijks": "yearly",
    "status onbekend": "status unknown",
    "niet verbonden": "not connected",
    "online": "online",
    "offline": "offline",
    "Uit": "Out",

    // ── MEP-module — aanvullende vertalingen ─────────────────────────────────
    "Los etiket printen": "Print standalone label",
    "Los etiket": "Standalone label",
    "Werkoverzicht": "Work overview",
    "Volledige lijst": "Full list",
    "Nog niets gepland": "Nothing planned yet",
    "Vink items aan in de volledige lijst. Daarna verschijnen ze hier automatisch per afdeling.":
      "Tick items in the full list. They will then appear here automatically by section.",
    "Lijst aanvullen": "Add to list",
    "Aanvullen": "Add items",
    "Klaar": "Done",
    "Morgen": "Tomorrow",
    "Alles": "All",
    "MEP": "Prep",
    "Bestelbon werkmodus": "Order sheet work mode",
    "Totaal": "Total",
    "Whiteboard": "Whiteboard",
    "Deze lijst vult zich vanzelf: items die je in de weekplanning aanvinkt en die bestelartikelen hebben, verschijnen hier - gegroepeerd per leverancier en klaar om te printen.":
      "This list fills automatically: items ticked in the weekly plan that have order items appear here, grouped by supplier and ready to print.",
    "Whiteboard - op": "Whiteboard - out",
    "Whiteboard - bijna op": "Whiteboard - almost out",
    "Whiteboard - op / bijna op": "Whiteboard - out / almost out",
    "geen hoeveelheid": "no quantity",
    "Geen regels voor dit filter.": "No lines match this filter.",
    "Geef je item een naam en kies een categorie. Koppel eventueel een recept, of voeg bestelartikelen toe — die komen dan automatisch op de bestelbon.":
      "Name your item and choose a category. Optionally link a recipe or add order items — they will then appear on the order sheet automatically.",
    "geen recept": "no recipe",
    "{n} gekozen": "{n} selected",
    "geen gekozen": "none selected",
    "dagen": "days",
    "{n} artikel(en)": "{n} item(s)",
    "geen bestelartikelen": "no order items",
    "Afdeling ": "Section ",
    "Categorie ": "Category ",
    "Print snel een etiket voor iets dat niet in je lijst staat — een restje, een bereiding of een los product. Dit voegt niets toe aan je mep-lijst.":
      "Quickly print a label for something not on your list — leftovers, a preparation or a standalone product. This does not add anything to your prep list.",
    "Wat komt er op het etiket?": "What should appear on the label?",
    "Het aantal etiketten kies je in het volgende scherm.":
      "Choose the number of labels on the next screen.",
    "Naar printen": "Continue to printing",
    "Geen recept gekoppeld — allergenen en bewaaradvies komen van het item zelf (aan te passen via ":
      "No recipe linked — allergens and storage advice come from the item itself (edit via ",
    "Klaar — terug naar lijst": "Done — back to list",

  },
};

// Maak een t-functie voor een bepaalde taal.
export function maakT(lang) {
  const dict = DICTS[lang] || DICTS.nl || {};
  return (key, vars) => {
    let s = dict[key];
    if (s == null) s = key; // val terug op de Nederlandse sleutel
    if (vars && s != null) {
      for (const k in vars) s = String(s).split("{" + k + "}").join(String(vars[k]));
    }
    return s;
  };
}

// Beste begintaal bepalen: opgeslagen keuze → tenant-standaard → browser → nl
export function bepaalStartTaal(tenantStandaard) {
  try {
    const opgeslagen = localStorage.getItem("kc-taal");
    if (opgeslagen && DICTS[opgeslagen]) return opgeslagen;
  } catch {}
  if (tenantStandaard && DICTS[tenantStandaard]) return tenantStandaard;
  try {
    const b = (navigator.language || "nl").slice(0, 2).toLowerCase();
    if (DICTS[b]) return b;
  } catch {}
  return "nl";
}

export function bewaarTaal(lang) {
  try { localStorage.setItem("kc-taal", lang); } catch {}
}

// Context zodat losse componenten (modules) t/lang/setLang kunnen oppikken.
const I18nCtx = createContext({ t: maakT("nl"), lang: "nl", setLang: () => {} });
export const I18nProvider = I18nCtx.Provider;
export function useT() { return useContext(I18nCtx); }

